import { useContext, useState, useMemo, useEffect, useCallback, useReducer, useRef } from 'react';
import { CheckInContext } from '../context/checkin';
import { Form, Container, Col, Row, InputGroup, Button } from "react-bootstrap";
import { isDate, formatDate } from '../functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera, faPen, faPlus, faTrash, faChevronDown, faChevronUp, faTimes } from '@fortawesome/free-solid-svg-icons';
import { getCDNImage } from "../globals";
import Screen from '../components/Screen';
import { T } from 'react-translator-component';
import PassengerForm from '../components/PassengerForm';

const CheckInEdit = () => {
  const refScreenSwipe = useRef(null);
    const { data: checkIn, save: checkInSave } = useContext(CheckInContext);
    const [ data, setData ] = useState(null);
    const [ errors, setErrors ] = useState({});
    const today = new Date(Date.now());


    const [passengerEdit, setPassengerEdit] = useState(null);
    const [croppingMode, setCroppingMode] = useState(false);
    const [cameraMode, setCameraMode] = useState(false);
    const [selfieToUpload, setSelfieToUpload] = useState(null);
    const [dniFrontToUpload, setDniFrontToUpload] = useState(null);
    const [dniBackToUpload, setDniBackToUpload] = useState(null);
    const [scrollY, setScrollY] = useState(0);



    const ageStats = useMemo(() => {
        const _stats = { adults: 0, boys : 0 }
        const _pass = data?.passengers ? data.passengers : checkIn?.passengers;
        _pass && _pass.map((row, idx) => {
          if (!isNaN(row.age)) {
            row.age >= 18 ? _stats.adults++ : _stats.boys++;
          }
        });
        return _stats;
    }, [data])
    
    const ageStatsText = useMemo(() => {
        let parts = [];
        if (ageStats.adults > 0) {
          parts.push(ageStats.adults + ' adulto' + (ageStats.adults > 1 ? 's' : ''))
        }
        if (ageStats.boys > 0) {
          parts.push(ageStats.boys + '  niño' + (ageStats.boys > 1 ? 's' : ''))
        }
        return parts.join(' / ')
    }, [data])

    const stay = useMemo(() => {
      let _r = { start: null, end: null }
  
      // TODO::: mejorar
      if (data?.dateStart && data?.dateStart.indexOf('T') !== -1) {
        const _arr = data.dateStart.split('T')
        _r["start"] = _arr[0]
      }
  
      if (data?.dateEnd && data?.dateEnd.indexOf('T') !== -1) {
        const _arr = data.dateEnd.split('T')
        _r["end"] = _arr[0]
      }
  
      return _r;
    }, [ data ])

    const save = useCallback(() => {
      console.log(data)
      setErrors({})
      const r = checkInSave(data)
        .then(r => console.log('RRRR', r))
        .catch(err => console.log('ERRRR', setErrors(JSON.parse(err.message))))
      console.log('R', r)

      // setButtonSaveDisabled(true);
      // TODO::: PARCHE para deshabilitar el botón
      // y prohibir el doble click, estaría mejor ir por el lado del dispatch con then pero no sé como se hace
      // setTimeout(() => {
      //   setButtonSaveDisabled(false);
      // }, 500)
      // ------------------
  
      // chekinSchema.validate(data, { abortEarly: false }).then(function () {
      //   data.language = language;
      //   dispatch(saveCheckIn(data))
      //   setEditMode(false);
      //   // API.graphql(graphqlOperation(createCheckIn, { input: data })).then((response) => {
      //   //   console.log('response', response);
  
      //   // }).catch((response) => {
      //   //     console.log('error', response)
      //   //     // dispatch(failure(response.data.message));
      //   // });
      // }).catch(function (err) {
      //   console.log('err', err)
      //   const validationErrors = {};
      //   err.inner.forEach(error => {
      //     if (error.path) {
      //       validationErrors[error.path] = error.message;
      //     }
      //   });
      //   setErrors(validationErrors)
      // });
    }, [data])

    const editPassenger = useCallback((index) => {
      setPassengerEdit(index)
      console.log(`setPassengerEdit(${index})`)
      refScreenSwipe.current.classList.add('show')
    }, [])

    const closeEditPassenger = useCallback(() => {
      refScreenSwipe.current.classList.remove('show')
      console.log(refScreenSwipe.current.classList)
      setPassengerEdit(false)
    }, [])

    useEffect(() => {
        setData(checkIn)
    }, [checkIn])

    if (!data) {
        return (<p>Sin data</p>)
    }

    return (<Screen
      section={'checkin-detail'}
      title={'Check-In'}
      // description={i18nValue(sections[entity], 'desc', language)}
  >
        <Row>
            <Col>
                <h5 className="general-title">{T('checkin.reservation-data')}</h5>
            </Col>
        </Row>
        <Row className="mb-3">
            <Col xs={6}>
              <h6 className="general-text">{T('checkin.in')} <b className="text-danger">*</b></h6>
              <InputGroup hasValidation>
                <Form.Control
                  type={'date'}
                  value={stay.start}
                  onChange={event => setData({ ...data, dateStart: isDate(event.target.value) ? event.target.value : null })}
                  min={formatDate(today)}
                  isInvalid={errors.dateStart}
                />
                {errors.dateStart && <Form.Control.Feedback type="invalid">{errors.dateStart}</Form.Control.Feedback>}
              </InputGroup>
            </Col>
            <Col xs={6}>
              <h6 className="general-text">{T('checkin.out')}{/* <small className="text-muted">(Opcional)</small>*/}</h6>
              <Form.Control
                type={'date'}
                value={stay.end}
                onChange={event => setData({ ...data, dateEnd: event.target.value })}
                min={stay.start || formatDate(today)}
                isInvalid={errors.dateEnd}
              />
              {errors.dateEnd && <Form.Control.Feedback type="invalid">{errors.dateEnd}</Form.Control.Feedback>}
            </Col>
          </Row>
          <Row>
            <Col xs={6}>
              <h6 className="general-text">{T('checkin.travel-type')}</h6>
              <Form.Control as={'select'} placeholder={T('checkin.travel-type')} onChange={ event => {
                setData({...data, travelType : event.target.value });
              }} isInvalid={errors.travelType}>
                <option value="" selected={data.travelType === '' ? 'selected' : ''}>{T('select...')}</option>
                <option value="commercial" selected={data.travelType === 'commercial' ? 'selected' : ''}>Comercial</option>
                <option value="tourism" selected={data.travelType === 'tourism' ? 'selected' : ''}>Turístico</option>
                <option value="family" selected={data.travelType === 'family' ? 'selected' : ''}>Familiar</option>
                </Form.Control>
                {errors.travelType && <Form.Control.Feedback type="invalid">{errors.travelType}</Form.Control.Feedback>}
            </Col>
            <Col xs={6}>
              <h6 className="general-text">{T('checkin.passengers')}</h6>
              <Form.Control as={'input'} value={ageStatsText} disabled="disabled" />
            </Col>
          </Row>
          <Row>
            <Col>
                <h5 className="general-title">{T('checkin.passengers')}</h5>
            </Col>
        </Row>
          <Row>
            <Col>
              {data.passengers && data.passengers.map((p, index) => {
                let line1 = [ `#${index+1}` ];
                let line3 = [];
                console.log(p)
                if (p.gender !== "undefined") line1.push(T(`checkin.inputs.gender.${p.gender}`))
                if (p.dni && p.dni !== "0") line1.push(`${p.dniType} ${p.dni}`)
                if (p.email) line1.push(`${p.email}`)
                if (p.birthday) line3.push(`${T('checkin.date-of-birth')}: ${p.birthday}`)
                if (p.age) line3.push(`${T(`checkin.age`)}: ${p.age}`)

                line1 = line1.join(' - ')
                line3 = line3.join(' - ')

                return (
                <Container className="card-generic mb-2" style={{ paddingLeft: 9, paddingRight: 9 }}>
                  <Row>
                    <Col className="d-flex flex-row justify-content-between" style={{ gap: 10 }}>
                      <div className="d-flex flex-column" style={{ backgroundImage : p.photos?.selfie ? "url(" + getCDNImage(p.photos.selfie) + ")" : 'none', backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundColor: '#DDD', height: 30, width: 30, borderRadius: 15 }}></div>
                      <div className="d-flex flex-column" style={{ flexGrow: 1 }}>
                        <p className="mb-0 general-text-sm text-muted">{line1}</p>
                        <p className="mb-0 general-text">{p.surname}, {p.name}</p>
                        <p className="mb-0 general-text-sm text-muted">{line3}</p>
                      </div>
                      <div className="d-flex flex-column">
                        <a 
                          className="checkin-passenger-action"
                          onClick={() => {
                            editPassenger(index)
                          }}>
                            <FontAwesomeIcon size="sm" icon={faPen} color="#666"/>
                        </a>
                        {/* <a 
                          className="checkin-passenger-action"
                          onClick={() => {
                          if (window.confirm('Seguro desea eliminar el viajante?')) {
                            let { passengers } = data;
                            console.log('passengers', passengers)
                            delete(passengers[index]);
                            passengers = passengers.filter(p => p)
                            console.log('passengers', passengers)
                            setData({ ...data, passengers });
                          }
                        }}><FontAwesomeIcon size="sm" icon={faTrash} color="#666"/></a> */}
                      </div>
                    </Col>
                  </Row>
                </Container>
              )
              })}
              <div className="w-100 text-center">
                <a
                  className="link-primary"
                    // disabled={buttonSaveDisabled}
                    onClick={() => {
                      editPassenger(null)
                    }}>
                      {T('checkin.add-passenger')}
                </a>
              </div>
            </Col>
          </Row>
          <div className="footer-container">
            <Button
              size={'md'} 
              variant={'primary'} 
              type={'button'}
              block={true}
              // disabled={buttonSaveDisabled}
              onClick={save}>{`${data.status !== 'observed' ? T('checkin.save-checkin') : T('checkin.save-changes')}`}
            </Button>
          </div>
          <div className="screen-swipe" ref={refScreenSwipe}>
              <PassengerForm 
                key={passengerEdit} 
                index={passengerEdit} 
                initialData={data.passengers[passengerEdit]} 
                setPassengerEdit={setPassengerEdit} 
                setCroppingMode={setCroppingMode} 
                setCameraMode={setCameraMode} 
                selfieToUpload={selfieToUpload} 
                setSelfieToUpload={setSelfieToUpload} 
                dniFrontToUpload={dniFrontToUpload} 
                setDniFrontToUpload={setDniFrontToUpload} 
                dniBackToUpload={dniBackToUpload} 
                setDniBackToUpload={setDniBackToUpload} 
                setScrollY={setScrollY} 
                qtyPassenger={data.passengers.length}
                closeEditPassenger={closeEditPassenger} 
                onSave={(index, values) => {
                  console.log('onSave', values)
                  const { passengers } = data;
                  if (index !== null) {
                    passengers[index] = values;
                  } else {
                    passengers.push(values);
                  }
                  setData({ ...data, passengers });
                  closeEditPassenger()
                }
              } />
          </div>
          <aside className="screen-swipe-modal"></aside>
    </Screen>)
}

export default CheckInEdit;